import { useEffect, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { api } from 'api';
import { Button, themes } from 'libs/ui';
import { CountersList } from './counters-list';
import { CountersAdd } from './add/counters-add';
import { Buttons, Content } from './counters.styled';

export const Counters = (props) => {
  const { t } = useTranslation();

  const { clientId } = props;
  const [data, setData] = useState([]);
  const [ready, setReady] = useState(false);
  const [nextRefresh, setNextRefresh] = useState(false);

  /**
   * get current data as array
   * @returns
   */
  const getCurrentAsArray = () => {
    if (data?.length === 0) {
      return [];
    }
    return data.map((el) => {
      return el.zone_id;
    });
  };

  const currentArray = useMemo(() => {
    return getCurrentAsArray();
  }, [data]);

  useEffect(() => {
    const getData = () => {
      api.call('client_counters.list', { filter_params: { client_id: clientId }, sort_params: [], paging_params: { offset: 0, limit: 1000 } }).then((data) => {
        setData(data.items);
        setReady(true);
      });
    };
    getData();
    return () => {
      setData([]);
      setReady(false);
    };
  }, [nextRefresh]);

  /**
   * save limits
   */
  const save = () => {
    // console.log('🚀 ~ save ~ data:', data);
    // api
    //   .call('clients.set_limits', { client_id: clientId, limits: data })
    //   .then(() => {
    //     notify(t('messages.Лимиты ТС'), t('messages.Лимиты сохранены'), 'success');
    //   })
    //   .catch((error) => {
    //     // console.log('🚀 ~ save ~ error:', error);
    //     notify(t('messages.Лимиты ТС'), t('messages.Ошибка сохранения: ') + error.toString());
    //   });
  };

  const refresh = () => {
    setNextRefresh((val) => !val);
  };

  if (!ready) {
    return null;
  }

  // const valid = data?.length > 0;

  return (
    <Content>
      <CountersAdd refresh={refresh} currentArray={currentArray} clientId={clientId} />
      <CountersList data={data} refresh={refresh} />

      {/* <Buttons>
        <Button theme={themes.blue} onClick={save} disabled={!valid}>
          <i className="fa fa-save" />
          {t('buttons.Сохранить')}
        </Button>
      </Buttons> */}
    </Content>
  );
};
